export const pick = <T extends object, K extends keyof T>(obj: T, ...keys: K[]) => (
  Object.fromEntries(
    keys
      .filter(key => key in obj)
      .map(key => [ key, obj[key] ])
  ) as Pick<T, K>
)

export const compact = <T extends Record<string, any>>(obj: T): Partial<T> => {
  return (Object.keys(obj) as (keyof T)[]).reduce((acc, key) => {
    const value = obj[key]
    if ((typeof value === 'string' && value.length > 0) || Boolean(value)) {
      acc[key] = value
    }
    return acc
  }, {} as Partial<T>)
}
